import { designSystemColors, otherColors } from '@klv/shared/styles/colors';

const button = {
  ghost: {
    dark: {
      backgroundHover: designSystemColors.charcoal,
      border: designSystemColors.charcoal,
      text: designSystemColors.charcoal,
      textHover: designSystemColors.white,
    },
    light: {
      backgroundHover: designSystemColors.white,
      border: designSystemColors.white,
      text: designSystemColors.white,
      textHover: designSystemColors.charcoal,
    },
    active: otherColors.ghostActiveGray,
  },
  none: {
    dark: {
      outlineColor: designSystemColors.charcoal,
    },
    light: {
      outlineColor: designSystemColors.white,
    },
  },
  pill: {
    dark: {
      background: designSystemColors.charcoal,
      backgroundHover: designSystemColors.white,
      border: designSystemColors.white,
      borderHover: designSystemColors.white,
      text: designSystemColors.white,
      textHover: designSystemColors.charcoal,
    },
    light: {
      background: designSystemColors.white,
      backgroundHover: designSystemColors.charcoal,
      border: otherColors.gray70,
      borderHover: designSystemColors.charcoal,
      text: designSystemColors.charcoal,
      textHover: designSystemColors.white,
    },
  },
  primary: {
    dark: {
      background: designSystemColors.charcoal,
      backgroundHover: 'transparent',
      borderHover: designSystemColors.charcoal,
      text: designSystemColors.white,
      textHover: designSystemColors.charcoal,
    },
    light: {
      background: designSystemColors.white,
      backgroundHover: 'transparent',
      borderHover: designSystemColors.white,
      text: designSystemColors.charcoal,
      textHover: designSystemColors.white,
    },
  },
  tertiary: {
    dark: {
      text: designSystemColors.charcoal,
    },
    light: {
      text: designSystemColors.white,
    },
  },
};

export default button;
